module.exports = __webpack_public_path__ + "img/disperse-icon.76f7b3dd.png";